@if (hasChartData()) {
  <div class="position-relative mx-auto" style="height:60vh;max-height:500px">
    <canvas baseChart [data]="pieChartData()" [options]="pieChartOptions()" type="pie"></canvas>
  </div>
}
